import { Instagram } from 'lucide-react'

export function SiteFooter() {
  return (
    <footer className="border-border bg-background border-t py-8">
      <div className="text-muted-foreground mx-auto flex max-w-7xl flex-col items-center gap-4 px-4 text-center text-sm">
        <a
          href="https://instagram.com/fairmeadow.capital"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Fairmeadow Capital on Instagram"
          className="hover:text-primary transition-colors"
        >
          <Instagram className="h-5 w-5" />
        </a>
        <p>&copy; {new Date().getFullYear()} Fairmeadow Capital. All rights reserved.</p>
      </div>
    </footer>
  )
}
